import { useCallback } from 'react'
import { useMailStore } from '../stores/mailStore'
import { useAccountStore } from '../stores/accountStore'

/**
 * Returns a `starThread(threadId, isStarred)` callback that:
 * 1. Optimistically updates local state.
 * 2. Persists via JMAP setKeyword($flagged).
 */
export function useStarThread() {
  const { starThread: localStar } = useMailStore()

  return useCallback((threadId: string, isStarred: boolean) => {
    localStar(threadId, isStarred)

    const client = useAccountStore.getState().getActiveClient()
    if (!client) return

    client.setThreadKeyword(threadId, '$flagged', isStarred).catch(() => {})
  }, [localStar])
}
